
<template>
  <div>
    <el-dialog :visible.sync="wakeDialogVisible" title="" width="450px" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="wakeMain">
        <i class="el-icon-warning"></i>
        <div class="content">
          您当前登录的松鼠Ai账号由于长时间未登录存在安全风险，已进入冻结状态，如需继续使用您可进行账号唤醒操作。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doNotLogin">暂不登录</el-button>
        <el-button type="primary" @click="dealWithFreeze">立即唤醒</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="wakeSecondDialogVisible" title="" width="450px" :show-close="false"
      :close-on-click-modal="false">
      <div class="wakeMain">
        <i class="el-icon-warning"></i>
        <div class="content">
          您ID{{ campusId }}下的松鼠Ai账号正在被唤醒，请前往1{{ phone }}注册的钉钉同意团队邀请确认加入总部。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wakeSecondDialogVisible = false">暂不处理</el-button>
        <el-button type="primary" @click="wakeSecondDialogConfirm">已确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAccountFreezeDetail,
  getAccountDisableDetail,
  wakeUpAccount
} from "@/api/AddEmpolyee";

export default {
  data() {
    return {
      wakeDialogVisible: false,
      wakeSecondDialogVisible: false,
      campusId: '',
      phone: ''
    };
  },
  methods: {
    // 入口函数
    // "systemType"1.经销商系统 2.代理商系统 3.分析师系统
    // userId
    // accountId (统一账号时)
    async startUp(options, ...params) {
      this.options = options
      this.userId = options.userId
      this.loginParams = params
      this.type = 0

      const resFreeze = await this.getAccountFreezeDetail(options)
      const resDisable = await this.getAccountDisableDetail(options)

      this.resFreeze = resFreeze
      this.resDisable = resDisable
      console.log(resFreeze, resDisable, 'res')

      // 无冻结 走禁用逻辑
      if (resFreeze == 0) {
        if (resDisable == 0) {
          return true
        } else {
          this.$message.error('您的账号已禁用，请联系您的上级协调处理')
        }
      } else {
        this.wakeDialogVisible = true
      }

      return false
    },
    async startUpMounted(options) {
      this.userId = options.userId
      this.type = 1

      const resFreeze = await this.getAccountFreezeDetail(options)
      const resDisable = await this.getAccountDisableDetail(options)

      this.resFreeze = resFreeze
      this.resDisable = resDisable
      console.log(resFreeze, resDisable, 'res')

      // 无冻结 走禁用逻辑
      if (resFreeze == 0) {
        if (resDisable == 0) {
          return true
        } else {
          this.$message.error('您的账号已禁用，请联系您的上级协调处理')
        }
      } else {
        this.wakeDialogVisible = true
      }

      return false
    },
    wakeUpAccount() {
      let param = { userId: this.userId }
      this.options.accountId&& (param = this.options)
      return wakeUpAccount(param).then(({ code, message, data }) => {
        return data
      })
    },
    getAccountDisableDetail(options) {
      let params = JSON.parse(JSON.stringify(options))
      delete params.freezeNeedNotSystemType
      return getAccountDisableDetail(params).then(({ code, message, data }) => {
        console.log(code, message, data, 'getAccountDisableDetail')

        // 兜底
        if (code == 0 && !data) {
          return 0
        }

        return data.type
      })
    },
    getAccountFreezeDetail(options) {
      let params = JSON.parse(JSON.stringify(options))
      if (params.freezeNeedNotSystemType) {
        delete params.systemType
      }
      delete params.freezeNeedNotSystemType

      return getAccountFreezeDetail(params).then(({ code, message, data }) => {
        console.log(code, message, data, 'getAccountFreezeDetail')

        // 兜底
        if (code == 0 && !data) {
          return 0
        }

        const { campusId, phone, type } = data
        this.campusId = campusId
        this.phone = phone

        return type
      })
    },
    wakeSecondDialogConfirm() {

    },
    doNotLogin(){
      this.wakeDialogVisible = false
      if(this.type){
        this.$emit('logout')
      }
    },
    async dealWithFreeze() {
      // this.wakeDialogVisible = false
      // this.wakeSecondDialogVisible = true
      if (this.type) {
        const wakeUpAccount = await this.wakeUpAccount()
        if (wakeUpAccount) {
          this.wakeDialogVisible = false
          this.$message.success('唤醒成功')
        } else {
          this.$message.error('唤醒失败，请稍后重试')
        }
      } else {
        const wakeUpAccount = await this.wakeUpAccount()
        if (wakeUpAccount) {
          this.$emit("toDoLogin", ...this.loginParams);
        } else {
          this.$message.error('唤醒失败，请稍后重试')
        }
        this.wakeDialogVisible = false
      }
    }
  },
  components: {

  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.wakeMain {
  padding: 20px 20px 5px;
  display: flex;

  .content {
    font-size: 18px;
    color: black;
    font-weight: 400;
  }

  .el-icon-warning {
    margin-right: 10px;
    margin-top: 2px;

    &::before {
      font-size: 24px;
      color: #4a83e8;
      content: '\e7a3';
    }
  }
}



:deep(.el-dialog__header) {
  padding: 0px !important;
}

:deep(.el-dialog__body) {
  padding: 0px !important;
}
</style>